import { DateTime } from 'luxon';
import { fromCalendarDate } from '@/utils/calendar-date';

export function calculateAge(birthDate: string | Date, bookingStart: string | Date): number {
  const birth = fromCalendarDate(birthDate);
  const birthCalendar = DateTime.utc(
    birth.getUTCFullYear(),
    birth.getUTCMonth() + 1,
    birth.getUTCDate(),
  );
  const start = DateTime.fromJSDate(new Date(bookingStart)).startOf('day');
  return start.diff(birthCalendar, 'years').as('years');
}
